const vfilters = {
  // 转换字符串中html转义符
  unescape: function (html) {
    return /&/g.test(html) ? html
      .replace(html ? /&(?!#?\w+;)/g : /&/g, '&amp;')
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, "\"")
      .replace(/&#39;/g, "\'") : html;
  }
}
export { phoneRegion, fetchPhoneRegion } from "./phoneRegion";
export default vfilters
